<template>
    <div id="app">
        <Menu v-if=" !routeNavStatus && !['readBook','Home'].includes(routeName)"/>
        <Header v-if="routeNavStatus"/>
        <router-view/>
        <!-- <Footers v-if="!['readBook'].includes(routeName)"/> -->
    </div>
</template>


<script setup>
import Menu from './components/menu.vue'
import Header from './components/header.vue'
import Footers from './components/footer.vue'
import {useRoute} from "vue-router/composables";
import {computed} from "vue";

const route = useRoute();
const routeName = computed(() => route.name);
const routeNavStatus = computed(() => route.meta.nav);
console.log(routeName, 123123)
</script>
<style lang="scss">
#app {
    background: #efefef;
}
body{
    background: #efefef;
}
</style>
